// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__YEgBo","left":"styles_left__2aS3l"};